module.exports = __webpack_public_path__ + "img/doc.baae0aae.svg";